import { render, staticRenderFns } from "./HueSlider.vue?vue&type=template&id=3fe035a5&scoped=true&"
import script from "./HueSlider.vue?vue&type=script&lang=js&"
export * from "./HueSlider.vue?vue&type=script&lang=js&"
import style0 from "./HueSlider.vue?vue&type=style&index=0&id=3fe035a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe035a5",
  null
  
)

export default component.exports